import React from "react";
import { Bar as BarChart } from "react-chartjs-2";

export const Barchartmaincat = (props) => {
  // Bar chart
  function chartData1() {
    return {
      labels: props.categoryname,
      datasets: [
        {
          label: "Population (millions)",
          backgroundColor: [
            "#ff0018",
            "#f7b11b",
            "#ff6c60",
            "#8663e1",
            "#08bf6f",
          ],
          data: props.totalorders,
        },
      ],
    };
  }
  const options = {
    legend: { display: false },
    title: {
      display: true,
      // text: 'Predicted world population (millions) in 2050'
    },
  };

  return <BarChart data={chartData1} options={options} />;
};

export default Barchartmaincat;
